import { BaseStats } from './BaseStats';

export interface BasePlugin {
  name: string; // 插件名称，用于去重
  stats?: BaseStats;
  option?: object;
  setup: (stats: BaseStats) => void; // 初始化代码, 传入监控实例
}

/**
 * 合并插件option
 * @param defaultOpt
 * @param newOpt
 */
export const mergePluginOption = (defaultOpt: any, newOpt: any) => {
  if (typeof newOpt === 'object') {
    Object.assign(defaultOpt, newOpt);
  }
};
